import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"จัดการมรดก & ผู้จัดการมรดกในไทย — ยื่นศาล/แบ่งทรัพย์สิน","metaTitle":"จัดการมรดก ผู้จัดการมรดก ยื่นศาล 35,000 บาท | NYC","metaDesc":"บริการจัดการมรดกครบวงจร — ยื่นศาลตั้งผู้จัดการมรดก แบ่งทรัพย์สิน โอนที่ดิน ปิดบัญชี ตาม ป.พ.พ. บรรพ 6 ค่าบริการ — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ"},"en":{"h1":"Thai Estate Administration & Executor Petition — CCC Book 6","metaTitle":"Thailand Estate Administration — Court Executor from THB 35,000 | NYC","metaDesc":"End-to-end estate administration in Thailand — court petition, executor appointment, asset distribution, land transfer, inheritance tax under CCC Book 6."}} as const;

export const Route = createFileRoute("/en/family/inheritance")({
  head: () => {
    const url = `${SEO_SITE}/en/family/inheritance`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/family/inheritance", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/family/inheritance", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/family/inheritance", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/family/inheritance", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/family/inheritance", "/en/family/inheritance")],
    };
  },
  component: () => <SubServicePage slug="family/inheritance" locale="en" />,
});
